export default "__VITE_ASSET__DYcztV0P__"